export const MULTISELECT_ENABLED = "checked";
export const WAIT_USER_ANSWER_DATA = "WAIT_USER_ANSWER_DATA";
export const DEFAULT_RESULT_VALUE = "";
